"use client";

import Image from "next/image";

import { WhatWeDoSvgs } from "./data";
import { getIcon } from "@/lib/utils";

export default function WhatWeDo() {
  return (
    <section
      id="what-we-do"
      className="relative max-w-[1525px] w-full overflow-hidden mt-14"
    >
      <Image
        src="/images/WhatWeDo.png"
        alt="Background Pattern"
        fill
        className="object-cover"
      />
      <div className="relative z-10 px-4 py-10 pb-8 sm:pb-10">
        <div className="max-w-[1100px] mx-auto">
          <h2 className="sm:text-[4.2rem] text-4xl sm:font-medium font-normal text-white mb-10 sm:mb-8">
            What We Do
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-6 mb-5">
            {/* Empty first column in first row */}
            <div className="hidden sm:block" />

            {/* First row */}
            {WhatWeDoSvgs.slice(0, 3).map((item) => {
              const IconComponent = getIcon(item.icon);
              return (
                <div
                  key={item.icon}
                  className="sm:w-[250px] px-6 w-full bg-[rgba(255,255,255,0.15)] backdrop-blur-lg rounded-xl py-6 text-center"
                >
                  <div className="flex justify-center mb-6">
                    <div className="bg-[rgba(212,212,212,0.10)] rounded-full w-16 h-16 flex items-center justify-center">
                      {IconComponent && (
                        <IconComponent className="w-8 h-8 text-white" />
                      )}
                    </div>
                  </div>
                  <h3 className="text-white sm:text-xl text-2xl mb-2 text-left">
                    {item.title}
                  </h3>
                  <p className="text-white font-extralight text-left text-lg sm:text-sm">
                    {item.description}
                  </p>
                </div>
              );
            })}

            {/* Second row */}
            {/* Second row */}
            {WhatWeDoSvgs.slice(3).map((item) => {
              const IconComponent = getIcon(item.icon);
              return (
                <div
                  key={item.icon}
                  className="sm:w-[250px] px-6 w-full bg-[rgba(255,255,255,0.15)] backdrop-blur-lg rounded-xl py-6 text-center"
                >
                  <div className="flex justify-center mb-6">
                    <div className="bg-[rgba(212,212,212,0.10)] rounded-full w-16 h-16 flex items-center justify-center">
                      {IconComponent && (
                        <IconComponent className="w-8 h-8 text-white" />
                      )}
                    </div>
                  </div>
                  <h3 className="text-white sm:text-xl text-2xl mb-2 text-left">
                    {item.title}
                  </h3>
                  <p className="text-white font-extralight text-left text-lg sm:text-sm">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
